module.exports = __webpack_public_path__ + "img/age-limit-3.ee2d6b70.svg";